// apps/portals/student/src/nav.ts — buildNav([…manifests], session, grants,
// enabled); ZERO hardcoded menu items (DEV-GUIDE-002 §6.4 / REPO-STRUCTURE.md
// §5.1).
//
// libStudentNav is PUBLIC-AWARE by construction: its catalogue entries carry no
// `perm`, so buildNav keeps them for anonymous visitors, while the /account
// entries carry lib:opac and vanish when signed out. That mirrors the router's
// two-halves gating instead of fighting it.
import { buildNav } from "@erp/auth-kit/nav";
import type { ModuleManifest, NavModule } from "@erp/auth-kit/nav";
import type { ModuleId, Session } from "@erp/core-schemas";
import { finStudentNav } from "@erp/module-fin/manifest";
import { libStudentNav } from "@erp/module-lib/manifest";
import { GRANTS } from "./grants";

const MANIFESTS: readonly ModuleManifest[] = [libStudentNav, finStudentNav];

/**
 * The sidebar for one session on one INSTALL. `enabled` is the capabilities
 * manifest's module set (ERP-DEPLOYMENT-MODEL §13): a manifest whose module the
 * install omits is dropped before the grant filter — and before the public
 * check too, so an install without `lib` shows an anonymous visitor no
 * catalogue entries either. The shell passes `caps.modules()` — `[]` while the
 * manifest is loading, which yields an empty sidebar exactly as a pending /me
 * does.
 */
export function studentNav(session: Session | null, enabled: readonly ModuleId[]): NavModule[] {
  return buildNav(MANIFESTS, session, GRANTS, enabled);
}
